export function loadScript(url: string, callback: () => void): void {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = callback;
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}
